/**
 * Unit of Measure Enum
 *
 * Defines the available unit types for materials:
 * - UMB: Unidad de Medida Base (Base Unit of Measure)
 * - UMP: Unidad de Medida Paralela (Parallel Unit of Measure)
 */
export enum UnitOfMeasureEnum {
  UMB = "UMB", // Unidad de Medida Base
  UMP = "UMP"  // Unidad de Medida Paralela
}
